/*
 * @Author: wb丁鹏程 jacyding1996@163.com
 * @FilePath: /mall-fe/src/api/common.ts
 * @Description: 公共接口
 */
import { fetch } from 'libs/fetch';

//通过区域名称查询区域信息
export async function getAreaByName(json = {}) {
  const res = await fetch('/api/mall/v1/mallArea/getAreaByName', {
    method: 'POST',
    json,
  });
  return res;
}

async function initCityPositionComponent() {
  const AMapLoader = await import('@amap/amap-jsapi-loader');
  const AMap = await AMapLoader.load({
    key: '088ad716a847a31b5e76945c51995b7a',
    version: '2.0',
    plugins: ['AMap.CitySearch'],
  });
  return new AMap.CitySearch();
}

export async function getIP() {
  let citySearch = await initCityPositionComponent();
  let city = await new Promise((resolve) => {
    citySearch.getLocalCity(function (status, result) {
      if (status === 'complete' && result.info === 'OK') {
        resolve(result.city);
      } else {
        resolve(undefined);
      }
    });
  });
  if (city) {
    try {
      const res = await getAreaByName({ areaName: city, type: 2 });
      return res;
    } catch (e) {
      console.error(e);
    }
  }
  return {};
}

/**
 * 获取地区
 * @param options
 */
export async function getAreas(options?: any) {
  const res = await fetch('/api/mall/v1/mallArea/areas', options);
  return res;
}

export async function getAreaBySysNo(sysNo: any) {
  const res = await fetch(`/api/ifs/v1/basis/area/get/${sysNo}`, {});
  return res;
}

export function areaDataByCondition(query: any): FetchPromise<AreaItem[]> {
  return fetch(`/api/ifs/v1/basis/area/searchByCondition`, {
    query,
    method: 'GET',
  });
}

export function getAreaTreeByGeo(query: any): FetchPromise<{ subAreas: AreaItem[] }> {
  return fetch(`/api/ifs/v1/basis/area/getAreaTreeByGeo`, {
    query,
    method: 'GET',
  });
}

export function getAreaTreeBySysNo(query: any): FetchPromise<{ subAreas: AreaItem[] }> {
  return fetch(`/api/ifs/v1/basis/area/areaTree`, {
    query,
    method: 'GET',
  });
}

export function getAreaByGeo(
  query: any,
): FetchPromise<{ areaCode: string; sysNo: string; fullName: string }> {
  return fetch(`/api/ifs/v1/basis/area/getAreaByGeo`, {
    query,
    method: 'GET',
  });
}

export interface Location {
  accuracy: string;
  errMsg: string;
  indoor_building_floor: string;
  indoor_building_id: string;
  indoor_building_type: string;
  latitude: string;
  longitude: string;
  speed: string;
}

export const getGeoPostion = (): Promise<Location> =>
  new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          console.log('XY 微信SDK定位成功', res);
          // res.latitude 纬度、res.longitude 经度
          resolve(res);
        },
        fail: function (err) {
          console.error('调用微信SDK失败: ', err);
          reject(err);
        },
      });
    });
  });

// 请求兼容，如果失败了回退到使用IP定位
export async function getAreaCodeByCurrentGeo() {
  let geoRes = null;
  try {
    geoRes = await getGeoPostion();
  } catch {
    console.error('微信环境获取定位失败');
    geoRes = null;
  }

  // 定位成功按定位查询，否则按IP
  const res = geoRes
    ? await getAreaByGeo({
        location: `${geoRes.longitude},${geoRes.latitude}`,
      })
    : await getIP();

  return res;
}

export async function getUnreadList(json) {
  const res = await fetch<any>('/api/ifs/v1/notify/message/searchNotifyMessagePageList', {
    method: 'POST',
    json,
  });
  return res;
}

export async function getHolidayByYear(yearList: number[]) {
  const res = await fetch<any>('/api/ifs/v1/holiday/getHolidayByYear', {
    method: 'POST',
    json: { yearList },
  });
  return res;
}

export async function getOrganizationParents(filterOrganizationCode: string) {
  const res = await fetch<any>('/api/ifs/v1/basis/organization/getOrganizationParents', {
    method: 'POST',
    json: { filterOrganizationCode },
  });
  return res;
}

export async function getFinancingConfig(
  organizationCode,
  materialCategorySysNos,
  effectScale,
  supplierSysNo,
) {
  const res = await fetch<any>('/api/financial/v1/financing/factor/getFinancingConfig', {
    method: 'POST',
    json: {
      organizationCode,
      materialCategorySysNos,
      effectScale,
      supplierSysNo,
    },
  });
  return res;
}

export async function getFactorOrgList(organizationCode: string) {
  const res = await fetch<any>('/api/mall/v1/purchaser/trade/shop/getFactorOrgList', {
    method: 'POST',
    json: {
      factor: true,
      organizationCode,
      // supplierSysNo, 不用传了
    },
  });
  return res;
}

export function getOrganization(sysNo) {
  return fetch(`/api/ifs/v1/basis/organization/get/${sysNo}`, {
    method: 'GET',
  });
}

export function getProject(sysNo) {
  return fetch(`/api/ifs/v1/basis/project/get/${sysNo}`, {
    method: 'GET',
  });
}

// 起点客服
export async function getService(json) {
  const res = await fetch('/api/qid/v1/common/loginCustomerService', {
    json,
    method: 'POST',
  });
  return res;
}

// 沃丰客服
//{
//  "userSysNo": "1234567890",
//  "supplierSysNo": "1234567890"
//  "sessionKey": "1234567890"
//  "tradeType": "1234567890"
//}
export async function getWofengService(json) {
  // 沃丰客服替换成opendesk
  const res = await fetch('/api/qid/v1/customer-service/access', {
    json,
    method: 'POST',
  });
  return res;
}

/**
 * @description 根据店铺编号查询 是否为云采店铺
 * @param shopSysNo 店铺编号
 * @returns
 */
export async function newCustomerServiceStatus(shopSysNo) {
  const res = await fetch(`/api/mall/v1/shop/newCustomerServiceStatus/${shopSysNo}`, {
    method: 'GET',
  });
  return res;
}

// 品牌查询
export function brandSearch(json: any): FetchPromise<any> {
  return fetch('/api/material/v1/brand/search', {
    method: 'post',
    json,
  }) as any;
}

// 品牌查询
export function getUserInOwnSupplier(supplierSysNo: any): FetchPromise<any> {
  return fetch(`/api/ifs/v1/authUser/getUserInOwnSupplier?supplierSysNo=${supplierSysNo}`, {
    method: 'GET',
  }) as any;
}

// 三局通消息详情查询
export function getSJTMessageDetail(id) {
  return fetch(`/api/ifs/v1/msg_platform/cscec3b/${id}`, {
    method: 'GET',
    needLogin: true,
  });
}

export async function getSJTMessageList(json, fileName) {
  const res = await fetch<any>('/api/basic/v2/newProject/downloadNewProject', {
    method: 'POST',
    json,
    downLoad: true,
    fileName,
  });
  return res;
}
